import React, { useState } from 'react';
import { Sparkles, Send } from 'lucide-react';
import { sapi } from '../../lib/api';
import { Spinner, useToast, Toast } from '../../components/UI';
import { useNavigate } from 'react-router-dom';

export default function AIApplicationPage(): React.ReactElement {
  const { toast, show } = useToast();
  const navigate = useNavigate();
  const [text, setText] = useState('');
  const [drafting, setDrafting] = useState(false);

  const draft = async () => {
    if (!text.trim()) return;
    setDrafting(true);
    try {
      const d = await sapi.aiDraft(text);
      if (!d.companyEmail) show("Drafted it, but couldn't find an email address — add it on the next screen", 'info');
      navigate('/student/apply', {
        state: {
          company: { name: d.companyName, email: d.companyEmail, address: d.address, managerName: d.managerName },
          jobTitle: d.jobTitle,
          cvId: d.cvId || undefined,
          coverLetterId: d.coverLetterId || undefined,
          emailBodyId: d.emailBodyId || undefined,
        },
      });
    } catch (e: any) { show(e.message || 'Failed to draft application', 'error'); }
    finally { setDrafting(false); }
  };

  return (
    <div className="page fade-in">
      {toast && <Toast msg={toast.msg} type={toast.type} />}
      <div className="page-header">
        <div>
          <h1 className="page-title">AI Application</h1>
          <p className="page-sub">Paste a job description or a recruiter's email — AI fills in the details and picks your CV, cover letter and email body. You review and send on the next screen.</p>
        </div>
      </div>

      <div className="card">
        <div className="form-group" style={{ marginBottom: 14 }}>
          <label><Sparkles size={10} style={{ marginRight: 4 }} />Job description or recruiter email</label>
          <textarea
            placeholder="Paste the job listing, or the email a recruiter sent you, here…"
            value={text}
            onChange={e => setText(e.target.value)}
            style={{ minHeight: 320, fontFamily: 'DM Sans, sans-serif', fontSize: 13 }}
          />
        </div>
        <button className="btn btn-primary" onClick={draft} disabled={!text.trim() || drafting}>
          {drafting ? <Spinner size={14} /> : <Send size={14} />} {drafting ? 'Drafting…' : 'Draft with AI'}
        </button>
        <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 10 }}>
          Needs a Groq API key in Settings, and at least one saved CV, cover letter and email body to choose from.
        </div>
      </div>
    </div>
  );
}
